import { FunctionalComponent, h } from 'preact';

import { IconTemplatePropsInterface } from 'common/module/icon/template-props.interface';

// tslint:disable:max-line-length
export const IconVerifiedBadge: FunctionalComponent<IconTemplatePropsInterface> = (props) => {
  return (
    <svg viewBox='0 0 38 38' className={props.class}>
      <path
        d='M15.3606 4.42237C17.246 2.13132 20.754 2.13132 22.6394 4.42237C23.6369 5.63437 25.1722 6.27032 26.7345 6.1186C29.6877 5.83178 32.1682 8.31229 31.8814 11.2655C31.7297 12.8278 32.3656 14.3631 33.5776 15.3606C35.8687 17.246 35.8687 20.754 33.5776 22.6394C32.3656 23.6369 31.7297 25.1722 31.8814 26.7345C32.1682 29.6877 29.6877 32.1682 26.7345 31.8814C25.1722 31.7297 23.6369 32.3656 22.6394 33.5776C20.754 35.8687 17.246 35.8687 15.3606 33.5776C14.3631 32.3656 12.8278 31.7297 11.2655 31.8814C8.31229 32.1682 5.83178 29.6877 6.1186 26.7345C6.27032 25.1722 5.63437 23.6369 4.42237 22.6394C2.13132 20.754 2.13132 17.246 4.42237 15.3606C5.63437 14.3631 6.27032 12.8278 6.1186 11.2655C5.83178 8.31229 8.31229 5.83178 11.2655 6.1186C12.8278 6.27032 14.3631 5.63437 15.3606 4.42237Z'
        fill='#39A76D'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.9409 12.6391C25.3492 12.2335 26.0133 12.2314 26.4242 12.6344C26.8351 13.0373 26.8373 13.6928 26.429 14.0984L17.6527 24.3288C17.2412 24.7375 16.5709 24.736 16.1613 24.3255L11.37 19.8335C10.9636 19.4261 10.9687 18.7707 11.3814 18.3695C11.7941 17.9683 12.4582 17.9734 12.8646 18.3807L16.9119 22.1271L24.9409 12.6391Z'
        fill='white'
      />
    </svg>
  );
};
